import { DI } from '@microsoft/fast-foundation';
import { defaultTemplateOptions } from './templates';
/**
 * Default HeaderConfig DI implementation.
 * @public
 */
export const defaultHeaderConfig = {
    name: 'foundation-header',
    templateOptions: defaultTemplateOptions,
};
/**
 * HeaderConfig DI key.
 *
 * @internal
 * @privateRemarks
 * Marked as internal to stop api-extractor becoming confused cross-linking tokens with the same name.
 */
export const HeaderConfig = DI.createInterface((x) => x.instance(defaultHeaderConfig));
